const plural = (count: number, unit: string) => `${count} ${unit}${count === 1 ? '' : 's'}`;

export const timeSinceContactLabel = (days: number): string => {
	if (days < 14) {
		return plural(days, 'day');
	}
	if (days < 60) {
		return plural(Math.round(days / 7), 'week');
	}
	if (days < 730) {
		return plural(Math.round(days / 30), 'month');
	}
	return plural(Math.floor(days / 365), 'year');
};
